const GameType = {};
GameType.emptyRow = () => {
    return {main: [], extra: []};
};
GameType.labels = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'];
GameType.EURO = {"name": "euroJackpot"};
GameType.EURO.mainNumbers = [1, 50];
GameType.EURO.extraNumbers = [1, 12];
GameType.EURO.mainMin = 5;
GameType.EURO.mainMax = 5;
GameType.EURO.extraMin  = 2;
GameType.EURO.extraMax  = 2;
GameType.EURO.stake = 200;
GameType.EURO.logo = "/digilipik/img/eurojackpot_solid.svg"

GameType.KENO = {"name": "keno"};
GameType.KENO.mainNumbers = [1, 64];
GameType.KENO.mainMin = 1;
GameType.KENO.mainMax = 10;
GameType.KENO.logo = "/digilipik/img/Keno.svg";
GameType.VIKING = {"name": "viking"};
GameType.VIKING.mainNumbers = [1, 48];
GameType.VIKING.extraNumbers = [1, 5];
GameType.VIKING.mainMin = 6;
GameType.VIKING.mainMax = 6;
GameType.VIKING.extraMin  = 1;
GameType.VIKING.extraMax  = 1;
GameType.VIKING.stake = 150;
GameType.VIKING.logo = "/digilipik/img/vikinglotto.svg";
GameType.BINGO = {"name": "bingo"};
GameType.BINGO.stake = 200;
GameType.BINGO.logo = "/digilipik/img/bingo.svg";
GameType.BINGO.emptyRow = () => {
    return {editorOpen: true, selectedPosition: {x: 0, y:0}, numbers: [[], [], [], [], []]};
};
GameType.getGameType = (name) => {
    var res = Object.entries(GameType).find(gt => gt[1].name === name);
    return res[1];
};

export default GameType;